import { DocumentNode, gql } from '@apollo/client';

const ADD_USERS_TO_UNIT_MUTATION: DocumentNode = gql`
  mutation addUsersToUnit($unitId: Int! $userIds: [Int]!) {
    unit {
      addUsersToUnit(unitId: $unitId, userIds: $userIds)
    }
  }
`;

export { ADD_USERS_TO_UNIT_MUTATION };
